import styled from 'styled-components'

export interface Props {
  testId?: string
  height?: string
  width?: string
  color?: string
}

const StyledSkeleton = styled.div<{ $width?: string; $height?: string; $color?: string }>`
  display: inline-block;
  height: ${({ $height }) => $height || '1em'};
  position: relative;
  overflow: hidden;
  background-color: ${({ $color }) => $color || '#ddd'};
  width: ${({ $width }) => $width || '100%'};

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 40%,
      rgba(255, 255, 255, 0)
    );
    transform: translateX(-100%);
    animation: shimmer 5s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`

export const Skeleton = ({ testId, width, height, color }: Props) => (
  <StyledSkeleton
    data-testid={`skeleton-${testId}`}
    $width={width}
    $height={height}
    $color={color}
  />
)
